/* eslint-disable max-len */
import React from "react";

export const BackIcon = ({ onClick, className }) => {
  return (
    <div className={className} onClick={onClick} role="button" tabIndex={0}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
      >
        <path
          d="M1.65409 8.11292H18.1734C18.3925 8.11292 18.6026 8.19994 18.7575 8.35484C18.9124 8.50973 18.9994 8.71982 18.9994 8.93888C18.9994 9.15794 18.9124 9.36803 18.7575 9.52293C18.6026 9.67783 18.3925 9.76485 18.1734 9.76485H1.65409C1.43503 9.76485 1.22494 9.67783 1.07005 9.52293C0.915146 9.36803 0.828125 9.15794 0.828125 8.93888C0.828125 8.71982 0.915146 8.50973 1.07005 8.35484C1.22494 8.19994 1.43503 8.11292 1.65409 8.11292Z"
          fill="black"
        />
        <path
          d="M1.99536 8.93882L8.84593 15.7877C9.00103 15.9428 9.08816 16.1532 9.08816 16.3725C9.08816 16.5919 9.00103 16.8022 8.84593 16.9573C8.69084 17.1124 8.48049 17.1995 8.26115 17.1995C8.04181 17.1995 7.83146 17.1124 7.67636 16.9573L0.242659 9.5236C0.165739 9.44688 0.104712 9.35573 0.063073 9.25538C0.0214336 9.15504 0 9.04746 0 8.93882C0 8.83017 0.0214336 8.7226 0.063073 8.62225C0.104712 8.5219 0.165739 8.43076 0.242659 8.35403L7.67636 0.920326C7.83146 0.765232 8.04181 0.678101 8.26115 0.678101C8.48049 0.678101 8.69084 0.765232 8.84593 0.920326C9.00103 1.07542 9.08816 1.28577 9.08816 1.50511C9.08816 1.72445 9.00103 1.9348 8.84593 2.0899L1.99536 8.93882Z"
          fill="black"
        />
      </svg>
    </div>
  );
};
